<template>
  <div ref="containerRef" class="ui-buttons-group">
    <slot :short />
  </div>
</template>

<script setup lang="ts">
import { computed, useTemplateRef } from 'vue'

import { useElementSize } from '@vueuse/core'

const containerRef = useTemplateRef('containerRef')

const SHORT_WIDTH = 235

const { width } = useElementSize(containerRef)

const short = computed(() => width.value < SHORT_WIDTH)
</script>

<style>
.ui-buttons-group {
  @apply flex items-center justify-end;
  @apply gap-x-2;
}
</style>
